import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FormInputText } from '../../../common/formInputsV2/FormInputText';
import { FormInputSelect } from '../../../common/formInputsV2/FormInputSelect';
import {
  flagResponse, km_during_one_year, lastfifteenYears, months, vehicle_plate_types, vehiclesAmountInFamily,
} from '../../../common/constants';
import { FastQuoteLoading } from '../../../common/componentsV2/elements/FastQuoteLoading';
import { Label } from '../../../common/formInputsV2/styles/common';
import FormReactSelectBrand from '../../../common/formInputsV2/FormReactSelectBrand';
import FormReactSelectModel from '../../../common/formInputsV2/FormReactSelectModel';
import InputSelectTable from '../../../common/componentsV2/inputs/InputTable';
import { FormInputNumber } from '../../../common/formInputsV2/FormInputNumber';
import { FormInputPrice } from '../../../common/formInputsV2/FormInputPrice';
import { FormInputRadio } from '../../../common/formInputsV2/FormInputRadio';
import getAllowedPurchaseYears from '../../../common/helpers/getAllowedPurchaseYears';
import { FormLayout } from '../../../common/formInputsV2/FormLayout.styles';
import CollapsiblePanel from '../../../common/formInputsV2/CollapsiblePanel';
import { WarningButton, WarningHint } from '../../../common/formInputsV2/Button.styles';
import { WarningAlert } from '../../../common/formInputsV2/Alert.styles';

function AncillariStepOne({
  formDataFlow,
  updateFormData,
  register,
  errors,
  isValid,
  vehicleVersions,
  isLoadingFastQuote,
  brands,
  isLoadingVehicleModels,
  isLoadingVehicleVersions,
  vehicleModels,
  formData,
  showStepOneFields = false,
  setShowStepOneFields = () => {},
}) {
  return (
    <>
      <FormLayout>
        <div id="vehiclePlateDiv">
          <FormInputText
            error={formDataFlow.is_old_plate !== '2' ? errors.vehicle_plate?.message : undefined}
            label="Targa dell' auto"
            placeholder="Inserisci la targa"
            onChange={(value) => updateFormData({ vehicle_plate: value.toUpperCase() })}
            value={formDataFlow.vehicle_plate}
            valid={isValid('vehicle_plate')}
          />
          {errors.vehicle_plate?.message && formDataFlow.is_old_plate !== '2' && (
            <div className="mt-2 d-flex align-items-center justify-content-center flex-column">
              <WarningButton
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => updateFormData({
                  complete_manually: true,
                  is_old_plate: '2',
                })}
              >
                <FontAwesomeIcon icon={faWarning} />
                {' '}
                Forza Targa (Formato Non Standard)
              </WarningButton>
              <WarningHint>
                Usa il pulsante qui sopra solo se la targa ha un formato non standard.
              </WarningHint>
            </div>
          )}
          {formDataFlow.is_old_plate === '2' && (
            <WarningAlert className="alert alert-warning">
              <FontAwesomeIcon icon={faWarning} />
              <span>
                <strong>Targa forzata:</strong>
                {' '}
                Stai utilizzando una targa con formato non standard.
              </span>
            </WarningAlert>
          )}
        </div>
        <FormInputSelect
          registration={register('is_old_plate')}
          error={errors.is_old_plate?.message}
          valid={isValid('is_old_plate')}
          placeholder="-Tipo-"
          options={vehicle_plate_types}
          label="Tipo di Targa"
          onChange={(e) => {
            const value = e.target.value;
            if (value === '2') {
              updateFormData({
                is_old_plate: value,
                complete_manually: true,
              });
            }
          }}
        />
      </FormLayout>

      {isLoadingFastQuote === true && <FastQuoteLoading />}

      {formDataFlow.vehicle_plate !== ''
                && (!errors.vehicle_plate?.message || formDataFlow.is_old_plate === '2')
                && (formDataFlow.imm_vehicle_month !== ''
                    || formDataFlow.complete_manually === true) && (
                    <FormLayout id="nextInputsImmatricolationBrand">
                      <div className="row mt-2">
                        <Label as="span">Data di prima immatricolazione</Label>
                        <div className="col-12 col-md-8">
                          <FormInputSelect
                            registration={register('imm_vehicle_month')}
                            error={errors.imm_vehicle_month?.message}
                            valid={isValid('imm_vehicle_month')}
                            placeholder="-Mese-"
                            options={months}
                          />
                        </div>

                        <div className="col-12 col-md-4">
                          <FormInputSelect
                            registration={register('imm_vehicle_year')}
                            error={errors.imm_vehicle_year?.message}
                            valid={isValid('imm_vehicle_year')}
                            placeholder="-Anno-"
                            options={lastfifteenYears}
                          />
                        </div>
                      </div>
                      <FormReactSelectBrand
                        label="Marca"
                        values={{
                          vehicle_brand_code: formDataFlow.vehicle_brand_code,
                        }}
                        error={errors.vehicle_brand_code?.message}
                        valid={isValid('vehicle_brand_code')}
                        onChange={(item) => updateFormData({
                          vehicle_brand_code: item.vehicle_brand_code,
                        })}
                        options={brands}
                      />
                    </FormLayout>
      )}

      {formDataFlow.imm_vehicle_year ? (
        <>
          {formDataFlow.vehicle_brand_code && (
            <FormLayout id="nextInputModel">
              {isLoadingVehicleModels ? (
                <p className="text-center">Attendere prego...</p>
              ) : (
                <FormReactSelectModel
                  label="Modello"
                  values={{
                    vehicle_model_code: formDataFlow.vehicle_model_code,
                  }}
                  error={errors.vehicle_model_code?.message}
                  valid={isValid('vehicle_model_code')}
                  onChange={(item) => updateFormData({
                    vehicle_model_code: item.vehicle_model_code,
                  })}
                  options={vehicleModels}
                />
              )}
            </FormLayout>
          )}
          {formDataFlow.vehicle_brand_code
                        && formDataFlow.vehicle_model_code ? (
              isLoadingVehicleVersions ? (
                <p className="text-center">Attendere prego...</p>
              ) : formDataFlow.vehicle_model_code
                            && vehicleVersions.length > 0 ? (
                              <FormLayout id="versionCode">
                                <InputSelectTable
                                  TableHeader={(
                                    <div className="d-flex">
                                      <div className="col-7">Descrizione</div>
                                      <div className="col-1">CC</div>
                                      <div className="col-4">Data Veicolo</div>
                                    </div>
                                    )}
                                  label="Versione"
                                  name="vehicle_version_code"
                                  id="vehicle_version_code"
                                  options={vehicleVersions}
                                  selected={formDataFlow.vehicle_am_code}
                                  error={errors.vehicle_version_code?.message}
                                  valid={isValid('vehicle_version_code')}
                                  onSelectOption={(value) => updateFormData({
                                    vehicle_version_code: value.id,
                                    vehicle_am_code: value.am_code,
                                  })}
                                />
                              </FormLayout>
                ) : (
                  <div className="alert-general-error">
                    Nessuna versione trovata per questo modello!
                  </div>
                )
            ) : (
              ''
            )}
          {formDataFlow.vehicle_version_code && (
            <FormLayout id="restInputsStepOne">
              <hr />
              <CollapsiblePanel
                open={showStepOneFields}
                onToggle={() => setShowStepOneFields(!showStepOneFields)}
                openLabel="Detagli"
                closedLabel="Detagli"
              >
                <FormInputNumber
                  registration={register('weight')}
                  error={errors.weight?.message}
                  valid={isValid('weight')}
                  label="Peso dell'auto"
                  placeholder="Inserisci il peso in kg"
                />
                <FormInputNumber
                  registration={register('power')}
                  error={errors.power?.message}
                  valid={isValid('power')}
                  label="Potenza in kW"
                  placeholder="Inserisci la potenza in kW"
                />
                <FormInputSelect
                  label="Altra alimentazione"
                  registration={register('other_power_supply')}
                  error={errors.other_power_supply?.message}
                  valid={isValid('other_power_supply')}
                  placeholder="-Seleziona-"
                  options={formData.vehicle_fuels}
                />
                <FormInputSelect
                  label="Parcheggio auto"
                  registration={register('vehicle_parking')}
                  error={errors.vehicle_parking?.message}
                  valid={isValid('vehicle_parking')}
                  placeholder="-Seleziona-"
                  options={formData.parking_types}
                />
                <FormInputSelect
                  label="Antifurto"
                  registration={register('theft_protection_code')}
                  error={errors.theft_protection_code?.message}
                  valid={isValid('theft_protection_code')}
                  placeholder="-Seleziona-"
                  options={formData.theft_protections}
                />
                <FormInputSelect
                  label="Utilizzo"
                  registration={register('vehicle_usage')}
                  error={errors.vehicle_usage?.message}
                  valid={isValid('vehicle_usage')}
                  placeholder="-Seleziona-"
                  options={formData.vehicle_usage_types.filter(
                    (type) => type.vehicle_type === 'auto',
                  )}
                />
                <FormInputSelect
                  label="Km percorsi in un anno"
                  registration={register('predicted_km')}
                  error={errors.predicted_km?.message}
                  valid={isValid('predicted_km')}
                  placeholder="-Seleziona-"
                  options={km_during_one_year}
                />
                <FormInputSelect
                  label="Auto nel nucleo familiare"
                  registration={register('vehicles_owned')}
                  error={errors.vehicles_owned?.message}
                  valid={isValid('vehicles_owned')}
                  placeholder="-Seleziona-"
                  options={vehiclesAmountInFamily}
                />
              </CollapsiblePanel>
              {formDataFlow.imm_vehicle_year !== '' && (
                <div className="row mt-2">
                  <Label as="span">Mese e anno in cui hai comprato l'auto</Label>
                  <div className="col-12 col-md-8">
                    <FormInputSelect
                      registration={register('vehicle_purchased_month')}
                      error={errors.vehicle_purchased_month?.message}
                      valid={isValid('vehicle_purchased_month')}
                      placeholder="-Mese-"
                      options={months}
                    />
                  </div>

                  <div className="col-12 col-md-4">
                    <FormInputSelect
                      registration={register('vehicle_purchased_year')}
                      error={errors.vehicle_purchased_year?.message}
                      valid={isValid('vehicle_purchased_year')}
                      placeholder="-Anno-"
                      options={getAllowedPurchaseYears(
                        formDataFlow.imm_vehicle_year,
                      )}
                    />
                  </div>
                  <div className="col-12">
                    <FormInputPrice
                      label="Valore dell'auto in Euro"
                      placeholder={"Inserisci il valore dell'auto"}
                      name="vehicle_value"
                      error={errors.vehicle_value?.message}
                      onChange={(val) => updateFormData({ vehicle_value: val })}
                      value={formDataFlow.vehicle_value}
                      valid={isValid('vehicle_value')}
                    />
                  </div>
                  <FormInputRadio
                    name="tow_hook"
                    label="Hai montato il gancio di traino?"
                    paragraph="(iscritta a rimorchiatori, caravan, ecc.)"
                    options={flagResponse}
                    registration={register('tow_hook')}
                    error={errors.tow_hook?.message}
                  />
                </div>
              )}
            </FormLayout>
          )}
        </>
      ) : (
        ''
      )}
    </>
  );
}

export default AncillariStepOne;
